import { jsx as _jsx } from "react/jsx-runtime";
import styles from './Hatch.scss';
export default function Hatch({ size = 28, color = 'black', speed = 3.5, stroke = 4, }) {
    return (_jsx("div", { className: styles.container, style: {
            '--uib-size': size + '',
            '--uib-color': color,
            '--uib-speed': speed + 's',
            '--uib-stroke': stroke + '',
        }, children: _jsx("div", { className: styles.inner, children: _jsx("div", { className: styles.line }) }) }));
}
